import { Component, OnInit, Input, HostListener } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-launcher',
  templateUrl: './launcher.component.html',
  styleUrls: ['./launcher.component.scss']
})
export class LauncherComponent implements OnInit {
  @Input() symbol = 'help'
  @Input() title = 'Title'

  constructor(
  ) { }

  ngOnInit() {
  }

}
